// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"343":"bd31ff6d","486":"4c0a084b","592":"0418f231"}[chunkId] + ".chunk.js";
};